import script from "./ArgonAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonAvatar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__